export default (theme) => ({
  bit: {
    display: 'flex',
    flexDirection: 'column',
  },

  grid: {
    flex: 1,
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',

    '&:nth-child(odd)': {
      borderRight: `1px solid ${theme.palette.graphs.separatorLine}`,
    },

    '&:nth-child(1), &:nth-child(2)': {
      justifyContent: 'flex-start',
      borderBottom: `1px solid ${theme.palette.graphs.separatorLine}`,
    },

    '& span': {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',

      '&:first-child': {
        marginTop: 8,
        marginBottom: 10,
        color: 'rgb(123, 139, 153)',
        fontSize: 13,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'flex-start',
      },
      '&:nth-child(2)': {
        color: 'rgb(58, 190, 250)',
        fontSize: 28,
        fontWeight: 'bold',
        letterSpacing: '-1.75px',
        lineHeight: '28px',
        marginBottom: 8,
      },
      '&:nth-child(3)': {
        color: 'rgb(155, 173, 188)',
        fontSize: 11,
        fontWeight: 600,
      },
    },
  },

  itemExplanation: {
    display: 'flex',
    marginLeft: 4,
  },

  horizontal: {
    '&&': {
      borderBottom: 'none',
      borderRight: `1px solid ${theme.palette.graphs.separatorLine}`,
      padding: 0,
      '&:last-child': {
        borderRight: 'none',
      },
    },
  },
});
